import { IntervalCondition } from '../interval-condition/interval-condition';

class TwoAttributesIntervalCondition extends IntervalCondition {

  configureContextSensitiveHandling () {
  }

}

customElements.define('d-two-attributes-interval-condition', TwoAttributesIntervalCondition);
